import { memo } from "react";
import "./styleModal.css";
import useWindowsSize from "@/Hooks/useWindowsSize";
import { LogoMovilSVG } from "@/Components/Index";

type propsModal = {
  showModal: boolean;
  titleModal: string;
  setViewModal: () => void;
};

const ModalThankyou = ({ showModal, titleModal, setViewModal }: propsModal) => {
  const { width } = useWindowsSize();
  let titleOne = "Muchas gracias por su compra";
  let titleTwo = "¡Que tenga un excelente día!";
  return (
    <div
      className={`modal fade ${showModal ? "show d-block" : ""}`}
      tabIndex={-1}
      role="dialog"
      style={showModal ? { backgroundColor: "rgba(0,0,0,0.9)" } : {}}>
      <div
        className="modal-dialog modal-dialog-centered modal-xl"
        role="document">
        <div
          className="modal-content bg-light">
          <div className="modal-header">
            <div className="d-flex justify-content-center w-100">
              <LogoMovilSVG
                widths={"42"}
                height={"42"}
                fillOne={"#d52b1e"}
                fillTwo={"#BCC032"}
              />
            </div>
          </div>
          <div className="modal-body w-100">
            <div className="d-flex justify-content-center mt-4">
              {width >= 1200 ? (
                <h1 className="develop___text">{titleOne}</h1>
              ) : width >= 999 && width < 1200 ? (
                <h2 className="develop___text">{titleOne}</h2>
              ) : (
                <h3 className="develop___text">{titleOne}</h3>
              )}
            </div>
            <div className="d-flex justify-content-center">
              <h4 className="develop___text">{titleTwo}</h4>
            </div>
            <div className="d-flex justify-content-center mt-3">
              <button
                className="text-white btn-circular"
                onClick={() => setViewModal()}>
                {titleModal}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(ModalThankyou);
